export const ADD_POST = 'ADD_POST';
export const ADD_MENU = 'ADD_MENU';
export const ADD_MEDIA = 'ADD_MEDIA';
export const CACHE_MEDIA = 'CACHE_MEDIA';
